"use strict";

exports.__esModule = true;
exports.GLOBAL_KEY = exports.ELEMENT_ID = void 0;
var ELEMENT_ID = 'redux-ssr';
exports.ELEMENT_ID = ELEMENT_ID;
var GLOBAL_KEY = '__PRELOADED_STATE__';
exports.GLOBAL_KEY = GLOBAL_KEY;